<template>
  <v-row>
    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.lastName"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.lastName.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.lastName)"
      >
        <template #label>
          <span class="required">Фамилия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.lastNameGenitive"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.lastNameGenitive.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.lastNameGenitive)"
      >
        <template #label>
          <span class="required">Фамилия в Родительном падеже</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.firstName"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.firstName.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.firstName)"
      >
        <template #label>
          <span class="required">Имя</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.firstNameGenitive"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.firstNameGenitive.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.firstNameGenitive)"
      >
        <template #label>
          <span class="required">Имя в Родительном падеже</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.middleName"
        label="Отчество"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.middleName.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.middleName)"
      />
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="localPersonalName.middleNameGenitive"
        label="Отчество в Родительном падеже"
        placeholder="Введите данные"
        outlined
        rounded
        dense
        @input="setPersonalName"
        @blur="$v.localPersonalName.middleNameGenitive.$touch()"
        :error-messages="$errorMessages($v.localPersonalName.middleNameGenitive)"
      />
    </v-col>
  </v-row>
</template>

<script>
import {PersonalName} from '@/models'
import {personalName} from "@/scripts/rules-validation";

export default {
  name: 'PersonalName',

  props: {
    personalName: PersonalName
  },

  data() {
    return {
      localPersonalName: new PersonalName()
    }
  },

  validations() {
    return {
      localPersonalName: { ...personalName },
    }
  },

  methods: {
    setPersonalName() {
      this.$emit('set-personal-name', this.localPersonalName)
    }
  },

  watch: {
    'personalName.id': {
      immediate: true,
      handler() {
        this.localPersonalName = PersonalName.build(this.personalName)
      }
    }
  }
}
</script>
<style scoped>

</style>
